// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import "babel-polyfill";
import store from "./store";

// import VueAwesomeSwiper from "vue-awesome-swiper";
// import "swiper/css/swiper.css";
// Vue.use(VueAwesomeSwiper);
Vue.config.productionTip = false;

//导入请求框架
import api from "./api";
//使用api
Vue.use(api);

import animated from "animate.css"; // npm install animate.css --save安装，再引入

Vue.use(animated);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js